import {
	CHECK_RELATED_INSPECTIONS,
	VALIDATE_CURRENT_INSPECTION,
	VALIDATE_CURRENT_INSPECTION_TAB
} from "../actions/validation";
import { UNLOAD_INSPECTION } from "../actions/inspection";

const initialState = {
	invalidTabs: [],
	invalidFields: [],
	isInspectionValid: true,
	relatedInspectionsCheck: true,
};

export default function validationReducer(state = initialState, action) {
	switch (action.type) {
		case UNLOAD_INSPECTION:
			return initialState;
		
		case CHECK_RELATED_INSPECTIONS:
			return {
				...state,
				relatedInspectionsCheck: action.checkRelatedInspectionsResult
			};

		case VALIDATE_CURRENT_INSPECTION: {
			const result = processValidationErrors(action);
			const valid = isInspectionValid(result);
			return {
				...state,
				invalidTabs: result.invalidTabs,
				invalidFields: result.invalidFields,
				isInspectionValid: valid
			};
		}
		
		case VALIDATE_CURRENT_INSPECTION_TAB: {
			const stateCopy = JSON.parse(JSON.stringify(state));
			const result = processValidationErrors(action);

			stateCopy.invalidTabs =
				stateCopy.invalidTabs.filter(t => t !== action.tabName)
					.concat(result.invalidTabs.filter(t => t === action.tabName));
			stateCopy.invalidFields =
				stateCopy.invalidFields.filter(f => f.error.tab !== action.tabName)
					.concat(result.invalidFields.filter(f => f.error.tab.startsWith(action.tabName)));
			stateCopy.isInspectionValid = isInspectionValid(result);
			return stateCopy;
		}
		
		default:
			return state;
	}
}

function _createPathObject(e) {
	const pathParts = e.dataPath.split('.');
	const path = {
		tab: pathParts[1],
		card: pathParts[2],
		field: pathParts[3],
		group: pathParts[4],
		origError: e,
		get fullPath() {
			const cp = checkProperty;
			if (cp(this.tab) && cp(this.card) && cp(this.group) && cp(this.field))
				return `${this.tab}.${this.card}.${this.group}.${this.field}`;
			if (cp(this.tab) && cp(this.card) && cp(this.field))
				return `${this.tab}.${this.card}.${this.field}`;
			if (cp(this.tab) && cp(this.card))
				return `${this.tab}.${this.card}`;
			if (cp(this.tab))
				return `${this.tab}`;
			return '';
		}
	};
	return path;
}

function _processArrayItemGroupArrayFieldMissing(path, e) {
	let openBracketsCount = 0, closeBracketsCount = 0;
	for (const c of e.dataPath) {
		if (c === '[') openBracketsCount++;
		if (c === ']') closeBracketsCount++;
	}
	if (e.dataPath && openBracketsCount === 2 && closeBracketsCount === 2 && path.tab && path.card &&
        e.keyword === 'required') {
		let dp = e.dataPath.replace(/\[/gi, '.').replace(/\]/gi, '');
		let parts = dp.split('.');
		path.tab = parts[1];
		path.card = parts[2];
		path.group = parts[3].concat('.', parts[4]);
		path.field = e.params.missingProperty;
		return true;
	}
}

function _processArrayItemGroupArrayFieldInvalid(path, e) {
	let openBracketsCount = 0, closeBracketsCount = 0;
	for (const c of e.dataPath) {
		if (c === '[') openBracketsCount++;
		if (c === ']') closeBracketsCount++;
	}
	if (e.dataPath && openBracketsCount === 2 && closeBracketsCount === 2 && path.tab && path.card) {
		let dp = e.dataPath.replace(/\[/gi, '.').replace(/\]/gi, '');
		let parts = dp.split('.');
		path.tab = parts[1];
		path.card = parts[2];
		path.group = parts[3].concat('.', parts[4]);
		path.field = parts[5];
		return true;
	}
}

function _processGroupArrayFieldMissing(path, e) {
	let openBracketsCount = 0, closeBracketsCount = 0, dotsCount = 0;
	for (const c of e.dataPath) {
		if (c === '[') openBracketsCount++;
		if (c === ']') closeBracketsCount++;
		if (c === '.') dotsCount++;
	}
	if (e.dataPath && openBracketsCount === 1 && closeBracketsCount === 1 && dotsCount === 3 && path.tab && path.card &&
        e.keyword === 'required') {
		let dp = e.dataPath.replace(/\[/gi, '.').replace(/\]/gi, '');
		let parts = dp.split('.');
		path.tab = parts[1];
		path.card = parts[2];
		path.group = parts[3].concat('.', parts[4]);
		path.field = e.params.missingProperty;
		return true;
	}
}

function _processGroupArrayFieldInvalid(path, e) {
	let openBracketsCount = 0, closeBracketsCount = 0, dotsCount = 0;
	for (const c of e.dataPath) {
		if (c === '[') openBracketsCount++;
		if (c === ']') closeBracketsCount++;
		if (c === '.') dotsCount++;
	}
	if (e.dataPath && openBracketsCount === 1 && closeBracketsCount === 1 && dotsCount === 4 && path.tab && path.card) {
		let dp = e.dataPath.replace(/\[/gi, '.').replace(/\]/gi, '');
		let parts = dp.split('.');
		path.tab = parts[1];
		path.card = parts[2];
		path.group = parts[3].concat('.', parts[4]);
		path.field = parts[5];
		return true;
	}
}

function _processArrayItemRequiredFieldMissing(path, e) {
	const index = e.dataPath.indexOf('[');
	if (e.dataPath && index > -1 && e.dataPath[e.dataPath.length - 1] === ']' && e.keyword === 'required') {
		path.tab = e.dataPath.substring(1, index);
		path.card = Number.parseInt(e.dataPath.substring(index + 1 , e.dataPath.length - 1));
		path.field = e.params.missingProperty;
		return true;
	}
}

function _processArrayItemValidationFunc(path, e) {
	const openBracketIndex = e.dataPath.indexOf('[');
	const closeBracketIndex = e.dataPath.indexOf(']');
	if (e.dataPath && openBracketIndex > -1 && closeBracketIndex > openBracketIndex && e.keyword === 'validationFunc') {
		path.tab = e.dataPath.substring(1, openBracketIndex);
		path.card = Number.parseInt(e.dataPath.substring(openBracketIndex + 1 , closeBracketIndex));
		path.field = e.dataPath.substring(closeBracketIndex + 2,);
		return true;
	}
}

function _processArrayItemGroupFieldMissing(path, e) {
	const openBracketIndex = e.dataPath.indexOf('[');
	const closeBracketIndex = e.dataPath.indexOf(']');
	if (e.dataPath && openBracketIndex > -1 && closeBracketIndex > openBracketIndex && path.tab && path.card &&
		e.keyword === 'required') {
		path.tab = e.dataPath.substring(1, openBracketIndex);
		path.group = path.card;
		path.card = Number.parseInt(e.dataPath.substring(openBracketIndex + 1, closeBracketIndex));
		path.field = e.params.missingProperty;
		return true;
	}
}

function _processArrayItemGroupFieldInvalid(path, e) {
	const openBracketIndex = e.dataPath.indexOf('[');
	const closeBracketIndex = e.dataPath.indexOf(']');
	if (e.dataPath && openBracketIndex > -1 && closeBracketIndex > openBracketIndex && path.tab && path.card) {
		path.tab = e.dataPath.substring(1, openBracketIndex);
		path.group = path.card;
		path.card = Number.parseInt(e.dataPath.substring(openBracketIndex + 1, closeBracketIndex));
		return true;
	}
}

function _processRequiredTabMissing(path, e) {
	if (e.dataPath === '' && e.keyword === 'required') {
		path.tab = e.params.missingProperty;
		path.card = path.field = '';
		return true;
	}
}

function _processRequiredCardMissing(path, e) {
	if (path.tab && !path.card && !path.field && e.keyword === 'required') {
		path.card = e.params.missingProperty;
		path.field = '';
		return true;
	}
}

function _processRequiredFieldMissing(path, e) {
	if (!path.field && e.keyword === 'required') {
		path.field = e.params.missingProperty;
		return true;
	}
}

function _processGroupObjectFieldMissing(path, e) {
	if (path.tab && path.card && path.field && !path.group && e.keyword === 'required') {
		path.group = path.field;
		path.field = e.params.missingProperty;
		return true;
	}
}

function _processGroupObjectFieldError(path, e) {
	if (path.tab && path.card && path.field && path.group) {
		const tmp = path.group;
		path.group = path.field;
		path.field = tmp;
		return true;
	}
}

function processValidationErrors(action) {
	const result = {
		invalidTabs: [],
		invalidFields: []
	};
	
	if (!action.validationResult.valid) {
		const errors = action.validationResult.errors.map(e => {
			const path = _createPathObject(e);			

			if (_processArrayItemGroupArrayFieldMissing(path, e)) {
				return path;
			}
			if (_processArrayItemGroupArrayFieldInvalid(path, e)) {
				return path;
			}
			if (_processGroupArrayFieldMissing(path, e)) {
				return path;
			}
			if (_processGroupArrayFieldInvalid(path, e)) {
				return path;
			}
			if (_processArrayItemRequiredFieldMissing(path, e)) {
				return path;
			}
			if (_processArrayItemValidationFunc(path, e)) {
				return path;
			}
			if (_processArrayItemGroupFieldMissing(path, e)) {
				return path;
			}
			if (_processArrayItemGroupFieldInvalid(path, e)) {
				return path;
			}
			if (_processRequiredTabMissing(path, e)) {
				return path;
			}			
			if (_processRequiredCardMissing(path, e)) {
				return path;
			}
			if (_processRequiredFieldMissing(path, e)) {
				return path;
			}
			if (_processGroupObjectFieldMissing(path, e)) {
				return path;
			}
			if (_processGroupObjectFieldError(path, e)) {
				return path;
			}
			return path;
		});

		errors.reduce((acc, e) => {
			let tabParts = e.tab.split('.');
			let tab= e.tab;
			if(tabParts.length> 1);//this is a workaround for arrayGroups
			    tab = tabParts[0];
			if (acc.invalidTabs.indexOf(tab) === -1) {
				acc.invalidTabs.push(tab);
			}
			acc.invalidFields.push({ fullPath: e.fullPath, error: e });
			return acc;
		}, result);
	}


	return result;
}

function checkProperty(p) {
	return p !== undefined && p !== null && p !== '';
}

function isInspectionValid(validationResult) {
	return validationResult.invalidTabs.length === 0 && validationResult.invalidFields.length === 0;
}